import React, { useState } from 'react';

const DatePickerCell = ({
    id,
    value,
    isSelected = false,
    isFocused = true,
    isDisabled = false,
    styleOptions,
    focusedCellStyleOverride,
    nonFocusedCellStyleOverride,
    date,
    onClick
}) => {
    const [isHighlighted, setIsHighlighted] = useState(false);

    const defaultStyleOptions = {
        cellBackgroundColour: '#F0F0F0',
        cellTextColour: '#414141',
        cellBorderColour: '#BBBBBB',
        ...styleOptions
    };

    const cellStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: defaultStyleOptions.cellBackgroundColour,
        color: isDisabled ? '#D1D1D1' : defaultStyleOptions.cellTextColour,
        fontFamily: 'Roboto',
        fontSize: 15,
        fontWeight: 500,
        cursor: isDisabled ? 'default' : 'pointer',
        userSelect: 'none',
        KhtmlUserSelect: 'none',
        MsUserSelect: 'none',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none'
    };

    const focusedCellStyle = {
        ...cellStyle,
        border: '1px solid',
        borderColor: isHighlighted
            ? '#FFB50C'
            : defaultStyleOptions.cellBorderColour,
        backgroundColor: isSelected
            ? '#FAA800'
            : isHighlighted
            ? '#FDF1D6'
            : defaultStyleOptions.cellBackgroundColour,
        ...focusedCellStyleOverride
    };

    const nonFocusedCellStyle = {
        ...cellStyle,
        backgroundColor: isHighlighted
            ? '#FDF1D6'
            : defaultStyleOptions.cellBackgroundColour,
        ...nonFocusedCellStyleOverride
    };

    const handleClick = () => {
        if (!isDisabled && onClick) {
            onClick(date);
        }
    };

    const handleHover = () => {
        if (!isDisabled) {
            setIsHighlighted(!isHighlighted);
        }
    };

    return (
        <div
            id={isSelected ? 'selected-date' : id}
            style={isFocused ? focusedCellStyle : nonFocusedCellStyle}
            onMouseOver={handleHover}
            onMouseLeave={handleHover}
            onClick={handleClick}
        >
            {value}
        </div>
    );
};

export default DatePickerCell;
